import { ButtonBounds, BarBGBounds, FrameBounds } from "../types/Interface"

export default function getButtonBoundsList(width: number, height: number): { [key: string]: (ButtonBounds | FrameBounds | BarBGBounds) } {
  const BoundsList = {
    vertical: {
      playButton: {
        x: (width / 2) + 170,
        y: (height / 2) + 490,
        width: 180,
        height: 180
      },
      autoPlayButton: {
        x: (width / 2) + 170,
        y: (height / 2) + 345,
        width: 334 * .5,
        height: 94 * .5
      },
      payAmount: {
        x: (width / 2) - 170,
        y: (height / 2) + 500,
        width: 180,
        height: 95,
        fontSize: 22
      },
      totalWon: {
        x: (width / 2) - 170,
        y: (height / 2) + 365,
        width: 180,
        height: 95,
        fontSize: 22
      },
      winningElement: {
        x: (width / 2),
        y: (height / 2) - 450,
        width: 210,
        height: 210
      },
      optionsButton: {
        x: width / 2 + 230,
        y: (height / 2) - 510,
        width: 134 * .6,
        height: 136 * .6,
      },
      prizeChartButton: {
        x: width / 2 - 195,
        y: height * .5 -520,
        width: 334 * .5,
        height: 94 * .5,
      },
      soundButton: {
        x: width - 40,
        y: 40,
        width: 50,
        height: 50
      }
    },
    horizontal: {
      optionsButton: {
        x: Math.floor(width / 2 + 440),
        y: Math.floor(height / 2 - 190),
        width: 134 * .5,
        height: 136 * .5,
      },
      autoPlayButton: {
        x: Math.floor(width / 2 + 400),
        y: Math.floor(height / 2 + 250),
        width: 334 * .5,
        height: 94 * .5
      },
      playButton: {
        x: Math.floor(width / 2 + 400),
        y: Math.floor(height / 2 + 145),
        width: 120,
        height: 120
      },
      payAmount: {
        x: Math.floor(width / 2 + 400),
        y: Math.floor(height * .5 + 20),
        width: 180,
        height: 95,
        fontSize: 18
      },
      winningElement: {
        x: Math.floor(width / 2 - 400),
        y: Math.floor(height / 2 - 180),
        width: 160,
        height: 160
      },
      totalWon: {
        x: Math.floor(width / 2 - 400),
        y: Math.floor(height * .5 + 20),
        width: 180,
        height: 95,
        fontSize: 18
      },
      prizeChartButton: {
        x: Math.floor(width / 2 - 400),
        y: Math.floor(height / 2 + 250),
        width: 334 * .5,
        height: 94 * .5,
      },
      soundButton: {
        x: width - 40,
        y: 40,
        width: 50,
        height: 50
      }
    }
  }
  return BoundsList[width > height ? "horizontal" : "vertical"]
}